export const MAP_API_KEY = process.env.REACT_APP_RIZE_GOOGLE_MAPS_API_KEY;

export const LIBRARIES = ['places'];

export const MAP_CONTAINER_STYLE = {
  width: 'auto',
  minHeight: '65dvh',
};

export const COUNTRY_LOCATIONS = {
  Indonesia: {
    lat: -6,
    lng: 123,
  },
  Vietnam: {
    lat: 14.0583,
    lng: 108.2772,
  },
};

export const MAP_TYPES = {
  SATELLITE: 'satellite',
  TERRAIN: 'terrain',
};
